{
  "name": "55-Quintal (Sabat Euler Lattice, center D)",
  "description": "55-tone 5-Limit Rational Intonation scale, based on Marc Sabat’s \"Euler Lattice Spirals Scenery\". Pythagorean diatonic tones are divided in a symmetric pattern of 9 \"commas\". To divide C 1/1 - D 9/8 add two notes above C: 81/80 and 25/24, then add two more notes one Syntonic Comma above each of these. Similarly, add two notes below D: 10/9 and 27/25; then, add two more notes a Syntonic Comma below each of these. To divide the limmas E-F and B-C, add two successive Syntonic Commas above the lower note and two Commas below the higher note, reaching a point of enharmonic near-equivalence between E and F.",
  "scale": [
    "81/80",
    "6561/6400",
    "25/24",
    "135/128",
    "16/15",
    "27/25",
    "800/729",
    "10/9",
    "9/8",
    "729/640",
    "59049/51200",
    "75/64",
    "1215/1024",
    "6/5",
    "243/200",
    "100/81",
    "5/4",
    "81/64",
    "6561/5120",
    "531441/409600",
    "25600/19683",
    "320/243",
    "4/3",
    "27/20",
    "2187/1600",
    "25/18",
    "45/32",
    "64/45",
    "36/25",
    "3200/2187",
    "40/27",
    "3/2",
    "243/160",
    "19683/12800",
    "25/16",
    "405/256",
    "8/5",
    "81/50",
    "400/243",
    "5/3",
    "27/16",
    "2187/1280",
    "177147/102400",
    "225/128",
    "3645/2048",
    "9/5",
    "729/400",
    "50/27",
    "15/8",
    "243/128",
    "19683/10240",
    "1594323/819200",
    "12800/6561",
    "160/81",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "55-JI-5L(Euler)",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "C",
    "C",
    "C",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "F",
    "F",
    "F",
    "F",
    "F",
    "F",
    "F",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "C",
    "C"
  ],
  "note_colors": [
    "#ffcaca",
    "#e9e1b4",
    "#dfd39a",
    "#ddd5a4",
    "#e6e0cb",
    "#c7c1a1",
    "#beb58f",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e9e1b4",
    "#dfd39a",
    "#ddd5a4",
    "#e6e0cb",
    "#c7c1a1",
    "#beb58f",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e9e1b4",
    "#dfd39a",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e9e1b4",
    "#dfd39a",
    "#ddd5a4",
    "#e6e0cb",
    "#c7c1a1",
    "#beb58f",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e9e1b4",
    "#dfd39a",
    "#ddd5a4",
    "#e6e0cb",
    "#c7c1a1",
    "#beb58f",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e9e1b4",
    "#dfd39a",
    "#ddd5a4",
    "#e6e0cb",
    "#c7c1a1",
    "#beb58f",
    "#fef5be",
    "#fffae5",
    "#ffffff",
    "#e9e1b4",
    "#dfd39a",
    "#fef5be",
    "#fffae5"
  ],
  "equivSteps": 55,
  "fundamental": 440,
  "reference_degree": 41,
  "center_degree": 9,
  "rSteps": 9,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3,
  "exquis_anchor_note": 9
}
